
import React from 'react';
import { useHistory } from 'react-router-dom'; 
import styles from './CreditCard.module.css';
import { t } from 'i18next';

const AddCard = React.forwardRef((props, ref) => {
  const history = useHistory(); 

  const handleClick = () => {
    history.push('/create-card');
  };

  return (
    <div ref={ref} className={styles.addCard} onClick={handleClick}>
      <div className={styles.addCardIcon}>+</div>
      <span className={`${styles.addCardText} bold`}>{t("addCard")}</span>
      <span className='font-extra-small text-secondary'>{t('debitorCredit')}</span>
    </div>
  );
});

export default AddCard;
